var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homeShow"},[_c('el-button',{staticClass:"btnClass",attrs:{"type":"primary"},on:{"click":_vm.submitForm}},[_vm._v("进入量表")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }